<mat-toolbar class="flex items-center header">
    <div class="w-full">
        <div class="flex flex-row items-center">
            <button [routerLink]="'/sessions'"><img class="logo clickable" src="/assets/logo.png"></button>
            <div class="spacer"></div>
            <button (click)="openHelp()" mat-icon-button matTooltip="FAQ">
                <mat-icon>help</mat-icon>
            </button>
        </div>
    </div>

</mat-toolbar>